import { ProductsMajor } from "@shopify/polaris-icons";
import { IMenuItems, MenuItemType } from "./MenuModel";
import ReelVideo from "components/icons/IconReelVideo";
import EventTrackingProvider from "api/services/EventTracingProvider";
import { ShopResponse } from "api/dtos/responses/shop/ShopResponse";
const instagram: IMenuItems = {
  id: "instagram",
  title: "Instagram Widget",
  type: MenuItemType.Group,
  icon: ProductsMajor,
  url: "instagram",
  featureHighlight: true,
  defaultExpand: true,
  children: [
    {
      id: "instagram-step",
      title: "Create widget",
      type: MenuItemType.Item,
      url: "/instagram-step-1",
      enableFeatureHighlightUrl: true
    },
    {
      id: "my-instagram-widget",
      title: "My widgets",
      type: MenuItemType.Item,
      url: "/my-instagram-widget",
      chip: {
        nameReducer: "InstagramWidgetReducer"
      }
    }
  ]
};

export const instagramReel: IMenuItems = {
  id: "instagram-reel",
  title: "Instagram Story",
  type: MenuItemType.Item,
  icon: ReelVideo,
  url: "",
  featureHighlight: true,
  onAfterClickMenu: (shop: ShopResponse) => {
    EventTrackingProvider.Track("home-page-instagram-reels", shop);
  }
};

export default instagram;
